import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faUser } from '@fortawesome/pro-light-svg-icons'

import { DashboardModuleListItem, Link, UserProfileImage } from '@domain-group/suit-theme'

import useAgent from '@hooks/useAgent'
import { UseAssignCampaignTeamOrAgentsPayload } from '@hooks/useAssignCampaignTeamOrAgents'

type AgentListItemProps = {
  agentId: number,
  callbacks: {
    removeAgent: UseAssignCampaignTeamOrAgentsPayload['callbacks']['removeAgent'],
  },
  compact?: boolean,
}

const AgentListItem = (props: AgentListItemProps) => {
  const { agentId, callbacks, compact } = props
  const { removeAgent } = callbacks

  const { image, user } = useAgent({ id: agentId })

  return (
    <DashboardModuleListItem
      boxProps={{
        bottomBorder: compact ? 'none' : undefined,
        paddingX: '0',
        paddingY: compact ? 'medium' : undefined,
      }}
      imageComponent={(
        // @ts-expect-error TS2339
        <UserProfileImage imageUrl={image?.thumb_url}>
          <FontAwesomeIcon icon={faUser} />
        </UserProfileImage>
      )}
      imageVariant="square"
      // @ts-expect-error TS2339
      title={user.full_name}
    >
      <Link
        greyLink
        onClick={() => removeAgent(agentId)}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>
    </DashboardModuleListItem>
  )
}

export default AgentListItem
